import React from "react";
import { ArrowRight, Rocket } from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { CAREER_ITEMS, IMAGES } from "../data/content";

export const Career = () => {
  const go = (h) => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="career" className="relative overflow-hidden bg-charcoal py-24 text-off-white sm:py-32" data-testid="career-section">
      <div className="grain absolute inset-0" />
      <div className="relative z-10 mx-auto grid max-w-[1400px] items-center gap-16 px-5 sm:px-8 lg:grid-cols-[1fr_0.8fr]">
        <div>
          <Reveal><Overline dark>Career Coaching & Professional Development</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
              Take Your Career <span className="text-gradient-gold">Beyond the Next Step</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-off-white/70 sm:text-lg">
              Practical career coaching for professionals seeking progression, career change, leadership opportunities
              or greater clarity about their professional direction.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
              {CAREER_ITEMS.map((c) => (
                <div key={c} className="flex items-center gap-2.5 text-sm text-off-white/85">
                  <span className="h-1.5 w-1.5 rounded-full bg-gold" /> {c}
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <button data-testid="career-cta-btn" onClick={() => go("#contact")}
              className="group mt-10 flex items-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-semibold text-emerald-darkest transition-transform duration-300 hover:-translate-y-1">
              <Rocket size={18} /> Book a Career Consultation
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl">
            <img src={IMAGES.career} alt="Professional progressing along a digital career pathway" className="aspect-[3/4] w-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
